import React from "react";
import styles from "./Contactinfo.module.css";
import Textfield from "../../../components/Textfield";
import { IoLocationOutline, IoPhonePortraitSharp } from "react-icons/io5";
import { MdOutlineMailOutline } from "react-icons/md";

const ContactInfo = ({ bgColor }) => {
  return (
    <div className={styles.contactInfo} style={{ backgroundColor: bgColor }}>
      <div className={styles.contactDetail}>
        <Textfield
          colorType="blue"
          type="h6"
          style={{ fontWeight: 400, color: "rgba(94, 178, 242, 1)" }}
        >
          Our Contact Details
        </Textfield>
        <Textfield colorType="blue" type="h1">
          Contact Us Now
        </Textfield>
        <Textfield
          colorType="blue"
          type="h5"
          style={{ marginTop: 10, fontWeight: 400 }}
        >
          Our expert team is here to attend to your queries.
        </Textfield>

        <div className={styles.contactList}>
          <div className={styles.contactItem}>
            <div className={styles.icon}>
              <IoPhonePortraitSharp color="#013A65" />
            </div>
            <Textfield colorType="blue" type="h6" style={{ fontWeight: 400 }}>
              +1-(361)-264-9510
            </Textfield>
          </div>
          <div className={styles.contactItem}>
            <div className={styles.icon}>
              <MdOutlineMailOutline color="#013A65" />
            </div>
            <Textfield colorType="blue" type="h6" style={{ fontWeight: 400 }}>
              support@dgadental.com
            </Textfield>
          </div>
          <div className={styles.contactItem}>
            <div className={styles.icon}>
              <IoLocationOutline color="#013A65" />
            </div>
            <Textfield colorType="blue" type="h6" style={{ fontWeight: 400 }}>
              Digident Global Academy,.Inc
              <br />
              108, Lakeland, Dover, County of Kent, Delaware, 19901, United
              States of America
            </Textfield>
          </div>
        </div>
      </div>
      <div className={styles.contactMap}>
        <div className={styles.blue}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d28168.75105246695!2d-81.96601851796872!3d28.052157947557383!3m2!1i1024!2i768!4f13.1!2m1!1sDigident%20Global%20Academy%2C.Inc%20108%2C%20Lakeland%2C%20Dover%2C%20County%20of%20Kent%2C%20Delaware%2C%2019901%2C%20United%20States%20of%20America!5e0!3m2!1sen!2sin!4v1739547677962!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ borderRadius: 10, border: 0 }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
